import { Location } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { IAuthorizationService, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
@Component({
    selector: 'modern-theme-header',
    templateUrl: 'modern-theme-header.component.html'
})
export class NxiModernThemeHeaderComponent implements OnDestroy, OnInit {

    @Input() hideLogoutButton: boolean = false;
    @Input() hideQuickQuote: boolean = false;
    @Input() isLoggedIn: boolean = false;
    @Input() showLanguageSwitch: boolean = false;
    showExit: boolean = false;
    isThemeSelector: boolean = false;
    isPotentialUser: boolean = false;
    ibdName: string;
    isDisclosuresPage: boolean = false;
    isMobileTheme: boolean = false;
    isLoggedInUser: boolean = false;
    isProfileActive: boolean = false
    logoUrl: string = '/nxi/login';

    isTabletTheme: boolean = false;
    currentUrl: any;
    ibdConfigMap: any;
    subs: Subscription;
    subs1: Subscription;
    isEdelEnabled: boolean = false;
    private appSettings: any;
    entitledForConatctUs: boolean;
    constructor(
        private router: Router,
        private authorizationService: IAuthorizationService,
        private location: Location,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-common', 'node_modules/@pershing/nxi-common/lib');
        this.translationService.addTranslationFolder('@pershing/nxi-portalcomponents', 'node_modules/@pershing/nxi-portalcomponents/lib');
        this.appSettings = appSettings;
        this.ibdConfigMap = appSettings.ibdConfigMap;
        if (appSettings.ibdConfigMap) {
            let parsemap = appSettings.ibdConfigMap;
            this.ibdName = parsemap.ibdName;
            this.isLoggedInUser = appSettings.isLoggedIn;
            this.isPotentialUser = appSettings.isPotentialUser;
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobileTheme = true;
        } else if (appSettings.deviceType && appSettings.deviceType === 'tablet') {
            this.isTabletTheme = true;
        }
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (urlArray[2] === 'disclosure') {
            this.isDisclosuresPage = true;
        }
        if (url.includes('/theme-selector')) {
            this.isThemeSelector = true;
        }
        this.resolveUrlFlags(url);
        this.entitledForConatctUs = this.authorizationService.isEntitled("CONTACT_BROKERAGE || ABOUT_US || FINANCIAL_ADVISOR || OUTSIDE_LINKS || DOWNLOAD_FORMS")
    }
    resolveUrlFlags(url) {
        if (url.includes('account-info-entry-nao') || url.includes('account-status-nao') ||
            url.includes('account-types-nao') || url.includes('account-creation-info-nao') ||
            url.includes('account-verid-nao') || url.includes('account-verid-qa-nao') || url.includes('account-new-userid-nao') ||
            url.includes('what-next') || url.includes('account-congrats-nao') || url.includes('add-fundstransfer') ||
            url.includes('digital-advise-splash') || url.includes('digital-advise-mixin') || url.includes('dt-consent') || url.includes('prospectAccount-login')
            || url.includes('dtAccountTransferConfirm') || url.includes('prospectAccounts')) {
            if (this.isPotentialUser) {
                this.showExit = true;
            }
            this.hideQuickQuote = true;
        } else {
            this.showExit = false;
        }
    }
    ngOnInit() {
        this.isLoggedIn = this.isLoggedInUser;
        if (this.isLoggedIn) {
            let suppressGoPaperless = false;
            if (this.ibdConfigMap && this.ibdConfigMap.suppressGoPaperless) {
                suppressGoPaperless = this.appSettings.ibdConfigMap.suppressGoPaperless;
            }
            // Certain IBDs need ELECTRONIC_NOTIFICATION enabled
            // but should not be shown with GoPaperless and Edelivery Preferences
            if (this.authorizationService.isEntitled('ELECTRONIC_NOTIFICATION') && (!suppressGoPaperless)) {
                this.isEdelEnabled = true;
            }
            this.logoUrl = '/nxi/overview';
        }
       this.routerEventsSubs();
    }

    routerEventsSubs() {
        this.subs = this.router.events.subscribe((url: any) => {
            // console.log('current url auth' + url.url);
            if (url.url) {
                this.currentUrl = url.url;
            }
            // Treat the duplicate confirmation screen as prelogin screen to hide logout
            // and other components.
            if (this.currentUrl.includes('duplicatesessionconfirmation')) {
                this.isLoggedIn = false;
            }
            this.resolveUrlFlags(this.currentUrl);
            if (this.currentUrl.includes('add-fundstransfer') || this.currentUrl.includes('account-congrats-nao') || this.currentUrl.includes('account-status-nao') || this.currentUrl.includes('welcome')) {
                this.hideQuickQuote = true;
            }
            if (this.currentUrl.includes('/login') || this.currentUrl.includes('/login1') || this.currentUrl.includes('/welcome') || !this.isLoggedIn) {
                this.logoUrl = '/nxi/login';
            }
            else {
                this.logoUrl = '/nxi/overview';
            }
        });
    }
    public ngOnDestroy() {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (this.subs1) {
            this.subs1.unsubscribe();
        }
    }
    messageCenter(): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/communications/messagecenter',
            }
        }));
    }

    eDeliveryPreferences(): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/allsettings/allsettingsSecLevel/edelpreferences',
            }
        }));
    }
}
